module.exports = "/images/no-highlight-image.jpg?85297ceb59403c6aaee1ca9c4159b991";